export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: "Who is SENfully for?",
    answer: "Families of children with autism and other special educational needs and disabilities (SEND) in the UK. It's for parents and carers first, with a place for grandparents, relatives and other trusted grown-ups too.",
  },
  {
    question: "How do I get SENfully?",
    answer: "SENfully is open by invitation while we're building it. Request access, tell us a little about your family if you'd like to, and we'll email you when your account is ready.",
  },
  {
    question: "Does my child need their own account?",
    answer: "No. A parent opens your child's board from their own account, and a child lock keeps it on screen. Children never sign in or see the grown-ups' side of the app.",
  },
  {
    question: "Does the talking board work without the internet?",
    answer: "Yes. Once your child's board has been opened on a device, it keeps working offline, so it's there in the car, at the park or when the Wi-Fi drops.",
  },
  {
    question: "Do I need to download it from an app store?",
    answer: "No. SENfully runs in your browser and installs to your home screen in a couple of taps, so it opens like any other app. On iPhone, open it in Safari and choose Share, then Add to Home Screen.",
  },
  {
    question: "Who can see my child's profile?",
    answer: "Parents and carers in your family see all of it. You choose which parts each grandparent, relative or carer can see, and you can change that whenever you like. Your child's date of birth is only ever seen by parents.",
  },
  {
    question: "Are the SEND guides advice?",
    answer: "They're plain-English guides to how SEND support works where you live, with links to the official sources. They're a starting point, not legal or medical advice, and we keep them under review.",
  },
  {
    question: "Who is Charlie?",
    answer: "Charlie is SENfully's helper for parents. Ask about EHCPs, school support, benefits or your rights, and Charlie answers in plain English from SENfully's checked SEND guides and shows you which ones. Like the guides, it's general information, not medical or legal advice.",
  },
  {
    question: "Is Charlie listening all the time?",
    answer: "No. Charlie only listens once you've tapped the mic, stops when you close voice mode, and pauses after a minute of quiet. Only the moment you're speaking is sent to be turned into text, using Microsoft's Azure speech service, and the recording isn't kept. The words become a normal message in your chat, which you can delete.",
  },
  {
    question: "Is the community safe?",
    answer: "You post under a community name, never your account name or email, and you confirm a photo doesn't identify a child before you post it. Anyone can report a post, and our team reviews every report.",
  },
  {
    question: "What happens to the details I send you?",
    answer: "We use your name and email only to reply to you and to review your request for access. There's more in our privacy notice.",
  },
];
